import { defineComponent as _defineComponent } from 'vue'
import TopModuleBlockViewModel = Vertica.LouisPoulsen.Application.Content.Blocks.TopModuleBlockViewModel;
import VideoPlayer from '@/ui/shared/VideoPlayer.vue';
import BackgroundVideoPlayer from '@/ui/shared/BackgroundVideoPlayer.vue';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockTopModule',
  props: {
    model: null
  },
  setup(__props: any) {

const props = __props as {model: TopModuleBlockViewModel}



const hasTopVideo = computed<boolean>(() => {
    return props.model.videoOnTop !== null && props.model.videoOnTop !== '';
});

const hasBackgroundVideo = computed<boolean>(() => {
    return props.model.backgroundVideoUrl !== null && props.model.backgroundVideoUrl !== '';
});

const hasBackgroundImage = computed<boolean>(() => {
    return props.model.backgroundImage !== null && props.model.backgroundImage !== '';
});

const hasLink = computed<boolean>(() => {
    return props.model.link !== null && !props.model.link.isEmpty && props.model.link.url !== '';
});

return { __sfc: true,props, hasTopVideo, hasBackgroundVideo, hasBackgroundImage, hasLink, VideoPlayer, BackgroundVideoPlayer }
}

})